<template>
  <CCard>
    <CCardHeader>
      <strong>Edit Bkash Banner</strong>
    </CCardHeader>
    <CCardBody>
      <CRow class="mt-3">
        <CCol sm="6">
          <CSelect label="Banner Type" :options="banner_types" :value.sync="banner.banner_type" />
        </CCol>
      </CRow>
      <CRow v-if="banner_url">
        <CCol sm="12" >
          <img :src="banner_url" style="width: 200px ;height:200px" />
          <br>
          <CButton color="danger" @click="removeBanner()">Remove Banner</CButton>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CInputFile
              label="Image thumbnail"
              vertical
              ref="image"
              type="image"
              id="image"
              @change="onImageChange"
          />
          <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
          <label class="text-danger"
          >*Image Size should be (750 X 126) for and less than 1 MB</label
          ><br>
          <label class="text-danger"
          >*Image Size should be (768 x 305) and less than 1 MB</label
          >
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <input class="m-3" type="checkbox" v-model="banner.is_published" />Publish
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CInput
              label="Weight"
              placeholder="Enter Weight"
              v-model="banner.weight"
          />
        </CCol>
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary"
      ><CIcon name="cil-check-circle" /> Add Banner</CButton
      >
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const ROOT_URL = process.env.VUE_APP_ROOT_URL;
export default {
  name: "BkashBannerEdit",
  data() {
    return {
      banner: {},
      banner_types: [{value:null,label:'None'}],
      banner_url:null
    };
  },
  created() {
    this.getBannerTypes()
    this.getBanner()
  },
  methods: {
    getBanner() {
      this.$axios
          .get(`${ADMIN_URL}/bkash-banner/${this.$route.params.id}`)
          .then((response) => {
            this.banner = response.data.banner;
            this.banner_url = ROOT_URL + "/" + this.banner.url;
            console.log('checkimage availabe',this.banner.url);
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    onImageChange(e) {
      console.log("event", e[0]);
      this.banner.url = e[0];
      if (this.banner.url === undefined) {
        return;
      }
      this.banner_url = URL.createObjectURL(this.banner.url);
    },
    convertTitle(s){
      return s.replace (/^[-_]*(.)/, (_, c) => c.toUpperCase())       // Initial char (after -/_)
          .replace (/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase());
    },
    getBannerTypes() {
      this.$axios
          .get(`${ADMIN_URL}/get-bkash-banner-types`)
          .then((response) => {
            response.data.forEach((e) => {
              console.log(e);
              this.banner_types.push({
                value: e,
                label: this.convertTitle(e),
              });
            });
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    removeBanner() {
      this.banner_url = "";
      this.banner.url = null;
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
        formData.append("id", this.banner.id);
      if(this.banner.banner_type!=null){
        formData.append("banner_type", this.banner.banner_type);
      }
      if(this.banner.url != null){
        formData.append("image", this.banner.url);
      }
      formData.append("is_published", Boolean(this.banner.is_published));
      formData.append("weight", this.banner.weight);

      this.$axios
          .post(`${ADMIN_URL}/bkash-banner/update`, formData, config)
          .then((response) => {
            console.log("Success", response);
            currentObj.success = response.data.success;
            console.log(response.data);
            this.$swal("Success", response.data.message, "success");
            window.location.href = "/bkash-promotions/banners";
          })
          .catch((error) => {
            console.log("Error  ... ", error.response);
            currentObj.output = error;
            this.$swal("Error", error.response.message, "error");
          });
    },
  },
};
</script>

<style scoped>
</style>
